export default "__VITE_ASSET__C3Ap1RFl__"